<style lang="less" scoped>
  .expense-wrapper{
    margin: 10px 0;
    padding-left: 10px;
    border-left: 3px solid #2b85e4;
  }
</style>
<template>
  <Modal 
    v-model="dis"
    title="编辑收款单"
    fullscreen
    :loading="saving"
    @ok="ok"
  >
    <template v-slot>
      <div style="width:800px;margin:auto">
        <VForm 
          ref="masterForm"
          v-model="model"
          :fields="masterForm"
        >
          <template v-slot:contact_unit_id="{field}">
            <VAccountSelector
              ref="vaccountselector"
              :label="field.label"
              :type="type"
              required
              :rules="field.rules"
              :text-render="accountTextRender"
              :apply_user_id="cur_customer.id"
              @on-change="selectedUnit"
            />
          </template>
          <template v-slot:contract_id="{field}">
            <AutocompletesAsyncS
              v-model="model"
              :field="field"
            />
          </template>
          <template v-slot:total_amount="{field}">
            <v-text-field
              :value="totalAmount"
              readonly
              :label="field.label"
              :rules="field.rules"
            />
          </template>
        </VForm>
        <div
          class="expenses-container"
        >
          <div
            v-for="(item,index) in model.items"
            :key="index"
            class="expense-wrapper"
          >
            <Childform 
              ref="childForm"
              v-model="model.items[index]"
              :bill_type="model.bill_type"
            />
            <v-row v-if="!is_period_closed">
              <v-col v-if="model.items.length===index+1">
                <v-btn
                  color="primary"
                  block
                  @click="addNewChild"
                >
                  <v-icon>mdi-plus</v-icon>
                  添加项目
                </v-btn>
              </v-col>
              <v-col v-if="model.items.length!==1">
                <v-btn
                  color="orange"
                  block
                  @click="deleteChild(index)"
                >
                  <v-icon>mdi-close</v-icon>
                  删除项目
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
  import { mapGetters } from "vuex";
  import Modal from '@/vuetify_custom/v-modal_v1'
  import VForm from '@/vuetify_custom/v-form'
  import Childform from './receipt_bill_card_modal_childform'
  import { util_api } from '@/libs/util_api'
  import VAccountSelector from '@/vuetify_custom/v-form/components_v/v-account-selector'
  import receipt_base from '../mixins/receipt_base'
  import receipt_modal_mixins from '../mixins/receipt_modal_mixins'
  import { receipt_types, unit_types } from '../fields'
  import AutocompletesAsyncS from '@/vuetify_custom/v-form/components/Autocompletes_Async_v2.js'
  const { fin_receipt_bill_items, fin_receipt_bill_update, fin_receipt_bill_create } = util_api
  const ruleValid = (text) => (val) => !!val || val === 0 || text
  // 母单需要填写的字段
  const master_key_arr = [
    'id',
    'bill_type', 
    'purpose_uid',
    'name', 
    'company_id',
    'receipt_bank_id',
    'currency',
    'contact_unit_type',
    'contact_unit_id',
    'handled_at',
    'remark',
    'contract_id'
    // 'team_id'
  ]
  const children_key_arr = [
    "name",
    "team_id",
    "expense_nature_id", // 费用natrue
    "customer_function_id", // 员工职能
    "customer_type", // 员工类型
    "item_type_id", // 产品类型
    "fund_usage_id", // 资金用途
    "is_insider_trading", // 内部交易
    "account_title_id", // 会计科目
    "analysis_title_id", // 分析科目 id
    "total_amount", // 总额
    "tax", // 税额
    "tax_rate", // 税率
    "invoice_type", // 发票类型
    "remark" // 备注
  ]
  export default {
    components: {
      Modal,
      VForm,
      Childform,
      VAccountSelector,
      AutocompletesAsyncS
    },
    mixins: [receipt_base, receipt_modal_mixins],
    data() {
      return {
        is_period_closed: true,
        bill_type: 'receipt_bill_card',
        master_key_arr,
        children_key_arr,
        update_api: fin_receipt_bill_update,
        create_api: fin_receipt_bill_create,
        items_api: fin_receipt_bill_items,
        statement_item_ids: [],
        from: null,
        contract_items: []
      }
    },
    computed: {
      ...mapGetters('async', 
                    [
                      'income_bill_types',
                      'banks', 
                      'currencies', 
                      'account_leaf_titles', 
                      'analysis_titles', 
                      'receipt_purposes',
                      'expense_natures',
                      'customer_functions',
                      'customer_types',
                      'item_types',
                      'fund_usages'
                    ]),
      masterForm() {
        return [
          {
            label: '单据类型',
            key:'bill_type',
            type:'select_field',
            'item-text': 'name',
            'item-value': 'uid',
            required: true,
            items: receipt_types,
            cols: 4,
            rules: [
              ruleValid('单据类型必选')
            ],
            change:(e) => {
              if (e === 'sale' && !this.model.id) {
                this.model.contact_unit_type = 'Client'
              }
            }
          },
          {
            label: '收款用途',
            key:'purpose_uid',
            type:'autocompletes',
            'item-text': 'name',
            'item-value': 'kingdee_uid',
            items: this.receipt_purposes,
            cols: 4,
            required: true,
            rules: [ ruleValid('收款用途必选') ],
            change:(data) => {
              const receipt_purposes_hash = this.receipt_purposes_hash
              const account_title_id = receipt_purposes_hash[data].account_title_id
              const analysis_title_id = receipt_purposes_hash[data].analysis_title_id
              this.model.items.forEach((item) => {
                item.account_title_id = account_title_id || item.account_title_id
                item.analysis_title_id = analysis_title_id || item.analysis_title_id
              }) 
            }
          },
          {
            label: '公司',
            key:'company_id',
            type:'company_select',
            cols: 4,
            required: true,
            rules: [ ruleValid('公司必选') ]
          },
          {
            label: '单据名称',
            key:'name',
            type:'text_field',
            required: true,
            cols: 6,
            rules: [ ruleValid('单据名称必填')]
          },
          {
            label: '业务日期',
            key:'handled_at',
            type:'date_picker',
            cols: 6,
            required: true,
            disabled: this.is_period_closed,
            rules: [ ruleValid('业务日期必选') ]
          },
          {
            
            label: '关联合同',
            key:'contract_id',
            type:'autocompletes_async_v1',
            'item-value':'id',
            'item-text':'uid_name',
                   
            // out_params: {
            //   payment_purpose: this.params.payment_purpose
            //   //   team_id: _this.params.team_id
            // },
            api: this.$util.api.contract_select_search,
            // init_list: [], // this.apply_user_list,
            cols: 6,
            clearable: true,
            items: this.contract_items,
            // items: this.contract_items,
            handle_data:({contracts}) => {
              const hash = this.contract_items.reduce((t, i) => {
                t[i.id] = true
                return t
              }, {})
          
              contracts.forEach(item => {
                if (hash[item.id]) {
                  return 
                }
                this.contract_items.push({
                  ...item,
                  uid_name: `${item.uid}-${item.name}`
                })
              });
            },      
     
            // change: (_, target = {}) => {
           
            //   setTimeout(() => {
            //     console.log('target', this.model.contract_id)
            //   }, 100)
            //   // _this.changeContract(target)
            // },
          },
          {
            label: '收款银行',
            key:'receipt_bank_id',
            type:'autocompletes',
            required: true,
            'item-text': ({bank, bank_number, account, del}) => `${bank}-${account}-${bank_number}${del && ' [已废弃]' || ''}`,
            'item-value': 'id',
            items: this.banks,
            cols: 6,
            rules: [ ruleValid('收款银行必选') ]
          },
          {
            label: '收款总金额（自动计算）',
            key:'total_amount',
            type:'number_field',
            cols: 3,
          },
          {
            label: '币别',
            key:'currency',
            type:'select_field',
            'item-text': ({name, code, symbol}) => {
              return `${name}-${code}-${symbol}`
            },
            'item-value': 'code',
            items: this.currencies,
            required: true,
            rules: [ ruleValid('币别必选') ],
            cols: 3
          },
       
          {
            label: '往来单位类型',
            key:'contact_unit_type',
            type:'select_field',
            'item-text': 'name',
            'item-value': 'uid',
            items: unit_types,
            required: true,
            disabled: !this.model.id && this.model.bill_type === 'sale',
            rules: [ ruleValid('往来单位类型必选') ],
            cols: 3,
          },
          {
            label: '往来单位',
            key:'contact_unit_id',
            cols: 6,
            required: true,
            rules: [ ruleValid('往来单位必选') ],
          },
          {
            label: '备注',
            key:'remark',
            type:'textareas_field',
            d_digits:2,
            cols: 12,
            counter: 500
          },
        ]
      },
      receipt_purposes_hash() {
        if (!this.receipt_purposes || !(this.receipt_purposes && this.receipt_purposes.length)) {
          return {}
        }
        return this.receipt_purposes.reduce((total, item) => {
          total[item.kingdee_uid] = item
          return total
        }, {})
      }
    },
 
    methods: {
      handleCreateBill({list = []} = {}) {
        this.show()
        let debit_amount = 0
        let credit_amount = 0
        const arr = [
          ['handled_at', 'transaction_date'],
          ['company_id', 'company_id'],
        ]
        /* ------------ 母单 ----------- */
        arr.forEach(([targetKey, sourceKey], index) => {
          this.model[targetKey] = list[0][sourceKey]
          if (targetKey === 'handled_at') {
            this.model[targetKey] = this.model[targetKey] > list[index][sourceKey] ? this.model[targetKey] : list[index][sourceKey]
          } else {
            this.model[targetKey] = list[0][sourceKey]
          }
        })
        /* ------------ 子单 ----------- */
        this.model.statement_item_ids = []
        list.forEach(item => {
          debit_amount += Number(item.debit_amount || 0)
          credit_amount += Number(item.credit_amount || 0)
          this.model.statement_item_ids.push(item.id)
        })
      
        this.model.items[0].name = '手动生成收款单'
        this.model.items[0].total_amount = list[0].debit_credit_flag === "debit" ? 0 - Number(debit_amount.toFixed(2)) : Number(credit_amount.toFixed(2))
        /* ---------------------------- */
        // this.model.bill_type = list[0]
        // this.dis = true
      }
    }
  }
</script>